/* eslint-disable react/no-multi-comp */

import React from "react";
import PropTypes from "prop-types";
import Modal from 'react-bootstrap/Modal';

class ConfirmOrdersSentMessage extends React.Component {
  render() {
    const { success, message } = this.props;
    const successStyle = success ? "green" : "red";
    return (
      <Modal
        show={this.props.open}
        backdrop="static"
        maxWidth="xs"
        aria-labelledby="confirmation-dialog-title"
      >
        <Modal.Header id="confirmation-dialog-title">
          <span style={{ color: `${successStyle}` }}>
            {success ? "Success!" : "Error"}
          </span>
        </Modal.Header>
        <Modal.Title>
          <Modal.Body id="alert-dialog-description">
            {message}
          </Modal.Body>
        </Modal.Title>
      </Modal>
    );
  }
}

ConfirmOrdersSentMessage.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.string,
  success: PropTypes.bool
};

export default ConfirmOrdersSentMessage;
